export { default } from "./Outro";
export * from "./Outro";
